<template>
  <div style="position: relative">
    <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
        :src="`https://aiplugin.5118.com/Pluginstat/?p=mouserank&v=${version}`"
        style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>
    <div dir="rtl" class="page">
      <div dir="ltr">
        <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
        <div class="row" style="margin: 10px 0;">
          <div class="col-15 left" style="text-align: left;line-height: 20px;font-size: 12px;">
            鼠标查排名功能
          </div>
          <div class="col-15 right">
            <span style="font-size: 12px;">{{ismouseopen}}</span>
            <v-switch v-model="mouseBaiduRankSwitch" style="z-index:10;"></v-switch>
          </div>
        </div>

        <div id="mousetopreturnmsg" v-if="greaterThan30">
            <div>已完成30个关键词排名查询，<br>
            若需继续请重新开启功能</div>
        </div>

        <div style="margin: 10px 0;text-align: right">
          <button class="btn is-plain" @click="exportList">
            <img src="../assets/image/export_ico.png" style="vertical-align: middle">
            导出数据
          </button>
        </div>
        <table class="mousebaidurank-table" style="table-layout: fixed">
          <thead>
          <tr>
            <th>关键词</th>
            <th>排名数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td  @click="jump_baidu(item.keyword,item.rank)" :title="item.keyword"  style="cursor: pointer;">{{item.keyword}}</td>
            <td style="padding-left: 5px;">{{item.rank.join(",")}}</td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
    <div class="div-bottom">
      <button class="btn btn-bottom" onclick="window.open('https://monitor.5118.com/keywords?f=plugin')">关键词排名持续监控</button>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex"

  export default {
    name: "MouseBaiduRank",
    watch: {
      mouseBaiduRankSwitch(newVal) {
        if(newVal){
          this.greaterThan30 = false;
          this.ismouseopen='已开启';
        }
        else
        {
          this.ismouseopen='已关闭';
        }
        this.$messenger.targets['parent'].send("Check-Mouse-BaiduRank", newVal);
      }
    },
    computed: {
      mouseBaiduRankSwitch: {
        get() {
          return this.$store.state.mouseBaiduRank.switch;
        },
        set(val) {
          this.$store.state.mouseBaiduRank.switch = val
        }
      },
      items: {
        get() {
          return this.$store.state.mouseBaiduRank.items;
        },
        set(val) {
          this.$store.state.mouseBaiduRank.items = val
        }
      },
      greaterThan30: {
        get(){
          return this.$store.state.badLink.greaterThan30
        },
        set(val){
          this.$store.state.badLink.greaterThan30 = val
        }
      },
      version:{
        get(){
          return this.$store.state.menu.version
        },
        set(val){
          this.$store.state.menu.version = val
        }
      },
      getdomain: {
        get() {
          return this.$store.state.menu.jump_domain_url;
        }
      },
      ismouseopen:{
        get() {
          return this.$store.state.mouseBaiduRank.ismouseopen;
        },
        set(val) {
          this.$store.state.mouseBaiduRank.ismouseopen = val
        }
      }
    },
    mounted() {
      this.ASetHistory("mousebaidurank").then(flag => {
        if (flag) {
          this.listenMouseBaiduRank()
        }
      });
    },
    methods: {
      ...mapActions("menu", ["ASetHistory"]),
      listenMouseBaiduRank() {

        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send("Mouse_Rank_Tack_Info");

        this.$messenger.listen("_5118_Mouse_BaiduRank_Info", (msg) => {
          if (msg && msg.length) {
            for (let item of  msg) {
              for (let j of this.$store.state.mouseBaiduRank.items) {
                if (j.keyword === item.keyword) {
                  j.rank = item.rank;
                  return ;
                }
              }
              // _hmt.push(['_trackEvent', 'MouseBaiduRank', 'Check']);
              this.$store.state.mouseBaiduRank.items.push(item)
              this.items.reverse();
            }
          }
        });
        this.$messenger.listen("_5118_Mouse_BaiduRank_Stop",(msg) =>{
          this.mouseBaiduRankSwitch = false;
          this.greaterThan30 = true;
        });
        this.$messenger.listen("_5118_MouseRank_State",(msg) =>{
          this.mouseBaiduRankSwitch = true;
        });
      },
      exportList(){
        this.$messenger.targets['parent'].send("_5118_Export","MouseBaiduRank");
      },
      jump_baidu(keyword,rank){
        String(rank).indexOf(',')==-1?rank=String(rank):rank=String(rank).split(',')[0];
        window.open('https://www.baidu.com/s?pn=0&rn=50&wd='+keyword+'&ie=utf-8&usm=1#'+rank)
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .mousebaidurank-table {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 70%;
      }
      &:nth-child(2) {
        width: 30%;
      }
    }
    td {
      &:nth-child(1) {
        color: @theme-color;
      }
    }
  }

#mousetopreturnmsg > div {
    background-color: #fdfae2;
    color: #fe950e;
    line-height: 25px;
    position: relative;
    padding: 5px 25px;
    font-size: 12px;
}

#mousetopreturnmsg > div:after {
    content: " ";
    position: absolute;
    display: block;
    border: 10px solid transparent;
    border-bottom: 10px solid #fdfae2;
    top: -19px;
    right: 10px;
}

</style>






// WEBPACK FOOTER //
// src/pages/MouseBaiduRank.vue